(() => {
  if (window.__searchAccessibilityInitialized) return;
  window.__searchAccessibilityInitialized = true;

  const init = () => {
    const button = document.querySelector('[data-element="search-button"]');
    const dialog = document.getElementById('search-modal');

    if (!button || !dialog) return;

    button.setAttribute('aria-controls', 'search-modal');
    button.setAttribute('aria-haspopup', 'dialog');

    const syncExpanded = () => {
      const isOpen = dialog.open;
      const wasOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        dialog.removeAttribute('inert');
        dialog.removeAttribute('aria-hidden');
        window.requestAnimationFrame(() => {
          dialog.querySelector('[data-element="search-input"]')?.focus();
        });
      } else {
        dialog.setAttribute('inert', '');
        if (wasOpen) button.focus();
      }
    };

    syncExpanded();

    dialog.addEventListener('close', syncExpanded);

    const observer = new MutationObserver(syncExpanded);
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
